import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class Footer extends ComponentBasePrototype {
  build() {
    this.accordionButtonClickHandler();
    this.windowResizeHandler();
    this.escapeKeyHandler();
  }

  // toggleSigns method toggles the visibility of the plus and minus signs in the accordion button.
  toggleSigns(targetButton, showPlus) {
    const plusSign = targetButton.find('.footer__links-toggle--open');
    const minusSign = targetButton.find('.footer__links-toggle--close');

    if (showPlus) {
      plusSign.show();
      minusSign.hide();
    } else {
      minusSign.show();
      plusSign.hide();
    }
  }

  //toggleAccordion method toggles the state of the accordion. If the accordion is expanded, it collapses it and vice versa.
  toggleAccordion(targetButton, targetContent, targetLinks, isExpanded) {
    const mainNav = $('.cms-navigation-2019__main');
    const notificationSection = $('.notificationSection');
    const teliaBreadcrumbs = $('.telia-breadcrumbs');
    const subNav = $('.sub-nav');
    const globalNotifications = $('.global-notifications');

    const headerHeight = mainNav.outerHeight() || 0;
    const notificationHeight = notificationSection.outerHeight() || 0;
    const breadcrumbsHeight = teliaBreadcrumbs.outerHeight() || 0;
    const subNavHeight = subNav.outerHeight() || 0;
    const globalNotificationsHeight = globalNotifications.outerHeight() || 0;

    if (isExpanded) {
      targetButton.attr('aria-expanded', 'false');
      targetContent.css('max-height', '0');
      targetLinks.attr('tabindex', '-1');
      targetContent.attr('hidden', ''); // to prevent focus of screen reader from moving inside the content when it's collapsed 
      this.toggleSigns(targetButton, true);
    } else {
      targetButton.attr('aria-expanded', 'true');

      // Calculating totalHeight of all target links and set it dynamically to the target content
      let totalHeight = 0;
      targetLinks.each(function () {
        // Including the margin, padding, and border in the total height calculation
        totalHeight += $(this).outerHeight(true);
      });
      let maxHeight = totalHeight + 'px';

      targetContent.css('max-height', maxHeight);
      targetLinks.attr('tabindex', '0');
      targetContent.removeAttr('hidden');
      this.toggleSigns(targetButton, false);

      setTimeout(() => {
        $('html, body').animate(
          {
            scrollTop: targetButton.offset().top - headerHeight - notificationHeight - breadcrumbsHeight - subNavHeight - globalNotificationsHeight,
          },
          300,
        );
      }, 500);
    }
  }
  // closeOtherAccordions method closes all other accordions when one is opened. It sets aria-expanded to false, hides the content, and sets tabindex to -1 for all other accordions and updates the plus minus signs
  closeOtherAccordions(targetButton, targetContent, accordionButtons, accordionContents) {
    const otherButtons = accordionButtons.not(targetButton);
    const otherContents = accordionContents.not(targetContent);

    otherButtons.attr('aria-expanded', 'false');
    otherContents.css('max-height', '0');
    otherContents.find('.footer__link').attr('tabindex', '-1');

    otherButtons.each((index, button) => {
      this.toggleSigns($(button), true);
    });
  }

  // addBlurHandler method adds a blur handler to the last link in the last accordion.
  // When the last link loses focus, it checks if the accordion is still the active element. If it's not, it collapses the accordion.
  addBlurHandler(targetButton, targetContent, targetLinks, accordionButtons) {
    if (targetButton.is(accordionButtons.last())) {
      targetLinks
        .last()
        .on('blur', (event) => {
          if (window.innerWidth < 601) {
            if (!targetContent.has(document.activeElement).length) {
              this.toggleSigns(targetButton, true);
              this.toggleAccordion(targetButton, targetContent, targetLinks, true);
            }
          }
        });
    }
  }

  // accordionButtonClickHandler method handles the click event on the accordion buttons.
  accordionButtonClickHandler() {
    const accordionButtons = this.node.find('.footer__navi-button');
    const accordionContents = this.node.find('.footer__link-list');

    accordionButtons.on('click', (event) => {
      if (window.innerWidth >= 601) return;

      const targetButton = $(event.currentTarget);
      const targetContent = $('#' + targetButton.attr('aria-controls'));
      const targetLinks = targetContent.find('.footer__link');
      const isExpanded = targetButton.attr('aria-expanded') == 'true';

      this.ensureVisibleOnFocus(targetButton);
      this.ensureVisibleOnFocus(targetLinks);
      this.closeOtherAccordions(targetButton, targetContent, accordionButtons, accordionContents);
      this.addBlurHandler(targetButton, targetContent, targetLinks, accordionButtons);
      this.toggleAccordion(targetButton, targetContent, targetLinks, isExpanded);
    });
  }

  // ensureVisibleOnFocus method ensures that the target element is visible when focused.
  ensureVisibleOnFocus(targetElements) {
    const mainNav = $('.cms-navigation-2019__main');
    const notificationSection = $('.notificationSection');
    const teliaBreadcrumbs = $('.telia-breadcrumbs');
    const subNav = $('.sub-nav');
    const globalNotifications = $('.global-notifications');

    targetElements.on('focus', function () {
      const element = $(this);
      const headerHeight = mainNav.outerHeight() || 0;
      const notificationHeight = notificationSection.outerHeight() || 0;
      const breadcrumbsHeight = teliaBreadcrumbs.outerHeight() || 0;
      const subNavHeight = subNav.outerHeight() || 0;
      const globalNotificationsHeight = globalNotifications.outerHeight() || 0;

      const elementTop = element.offset().top - headerHeight - notificationHeight - breadcrumbsHeight - subNavHeight - globalNotificationsHeight;
      const elementBottom = elementTop + element.outerHeight();
      const viewportTop = $(window).scrollTop();
      const viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportBottom || elementTop < viewportTop) {
        $('html, body').animate({ scrollTop: elementTop }, 100);
      }
    });
  }

  // escapeKeyHandler method handles the escape key press event.
  escapeKeyHandler() {
    let lastExpandedButton = null;
    const accordionButtons = this.node.find('.footer__navi-button');
    const accordionContents = this.node.find('.footer__link-list');

    accordionButtons.on('click', (event) => {
      const targetButton = $(event.currentTarget);
      if (targetButton.attr('aria-expanded') == 'true') {
        lastExpandedButton = targetButton;
      }
    });

    $(document).on('keydown', (event) => {
      if (window.innerWidth >= 601) return;

      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        accordionButtons.attr('aria-expanded', 'false');
        accordionContents.css('max-height', '0').find('.footer__link').attr('tabindex', '-1');

        this.toggleSigns(accordionButtons, true);

        if (lastExpandedButton) {
          lastExpandedButton.focus();
          lastExpandedButton = null;
        }
      }
    });
  }

  // windowResizeHandler method handles the window resize event.   
  // When the window is resized, it checks the window width and adjusts the state of the accordions accordingly. Resets the accordion state when the window width is greater than or equal to 601px.
  windowResizeHandler() {
    const accordionButtons = this.node.find('.footer__navi-button');
    const accordionContents = this.node.find('.footer__link-list');

    if (window.innerWidth < 601) {
      accordionContents.find('.footer__link').attr('tabindex', '-1');
      accordionContents.attr('hidden', '');
    } else {
      accordionContents.find('.footer__link').attr('tabindex', '0');
      accordionContents.removeAttr('hidden');
    }

    $(window).on('resize', () => {
      if (window.innerWidth >= 601) {
        accordionButtons.attr('aria-expanded', 'false');
        accordionContents.css('max-height', '');
        accordionContents.find('.footer__link').attr('tabindex', '0');
        accordionContents.removeAttr('hidden');
      } else {
        accordionButtons.each((index, button) => {
          const targetButton = $(button);
          const targetContent = $('#' + targetButton.attr('aria-controls'));
          if (targetButton.attr('aria-expanded') == 'false') {
            targetContent.find('.footer__link').attr('tabindex', '-1');
            targetContent.attr('hidden', '');
          }
        });
      }
    });
  }
}

